export const modeToTitle = (data: string) => {
  switch (data) {
    case 'approval':
      return '품의';
    case 'meeting':
      return '회의록';
    case 'new':
    case 'note':
    case 'note,new':
    default:
      return '기본';
  }
};
